var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit',{attrs:{"id":_vm.id,"detail":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }